import AdminChecklistView from "./AdminChecklistView";

export default AdminChecklistView;
